export default "__VITE_ASSET__CMLR6feC__"